import React from 'react';
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import {useActions} from "../../../actions";
import * as Aws from "../../../actions/aws";
import {Proposal} from "../../../model/proposal";
import {IllustrationDocumentType} from "../../../pages/client/Kids/AddRecipient";
import {NoConfirmProposalDialog} from "../../ProposalDialogs";
import {noop, va} from "../../../utils/commonUtils";


type IllustrationsProps = {
    item: any;
};

const Illustrations: React.FC<IllustrationsProps> = ({item}) => {
    const [reports, setReports] = React.useState<any>([]);
    const [loadingReports, setLoadingReports] = React.useState<any>([]);
    const [activeProposalTab, setActiveProposalTab] = React.useState(0);
    const awsActions = useActions(Aws);

    const getSecureFileUrl = async (bucketName: string, dir: string, file: string) => {
        const contentType = "text/pdf";
        const queryObj = {bucketName, contentType, objectName: file};
        return awsActions.getSecureUrl(dir, queryObj, true);
    };
    const handleOpen = async (userId: string) => {
        if (userId) {
            setLoadingReports(true);
            const proposalArr: Proposal[] = [];
            for (let i = 0; i < item.userIllustrations.length; i++) {
                const illDoc: IllustrationDocumentType = item.userIllustrations[i];
                if (!illDoc) continue;
                const pathArr: string[] = illDoc.path.split('/') || [];
                const directory = pathArr[0];
                const fileName = pathArr[1];
                const url = await getSecureFileUrl(illDoc.bucket, directory, fileName);
                proposalArr.push({name: illDoc.name, url: url});
            }
            setReports(proposalArr);
            setLoadingReports(false);
        }
    }

    return (
            <>
                <PictureAsPdfIcon
                        className="cursorPointer"
                        color="primary"
                        onClick={() => handleOpen(item && item.userId).then()}
                />
                {
                        !loadingReports && !!va(reports) &&
                        <NoConfirmProposalDialog
                                activeProposalTab={activeProposalTab}
                                setActiveProposalTab={setActiveProposalTab}
                                onClose={() => setReports([])}
                                proposalPdf={reports}
                                setEnableActions={noop}
                                userId={item && item.userId}
                                clientPolicyId={item && item.clientPolicyId}
                                title="Client Proposal"
                        />
                }
            </>
    );
};

export default Illustrations;
